import { render } from "./ProfitLossReport.vue?vue&type=template&id=0d0c719c&scoped=true"
import script from "./ProfitLossReport.vue?vue&type=script&lang=js"
export * from "./ProfitLossReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=0d0c719c&scoped=true&lang=css&external"
import "./accountingReport.css?vue&type=style&index=1&id=0d0c719c&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0c719c"]])

export default __exports__